import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-rate',
    templateUrl: './rate.component.html',
    styleUrls: ['./rate.component.scss']
})
export class RateComponent implements OnInit {
    comment = '';
    easy = 0;
    search = 0;
    simul = 0;
    general = 0;
    step = 0;
    platform: 'google' | 'trustpilot' = Math.random() < 0.5 ? 'google' : 'trustpilot';
    copied = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<RateComponent>,
        public userService: UserService,
        private alertService: AlertService,
        public authenticationService: AuthenticationService,
    ) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    startRate(): void {
        this.step = 1
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }

    onEasyClick(event) {
        this.easy = event.rating;
    }

    onSearchClick(event) {
        this.search = event.rating;
    }

    onSimulClick(event) {
        this.simul = event.rating;
    }

    onGeneralClick(event) {
        this.general = event.rating;
    }

    copyReview() {
        navigator.clipboard.writeText(this.comment).then(() => {
            this.copied = true;
        });
    }

    onSubmit() {
        if (this.easy != 0 && this.search != 0 && this.simul != 0 && this.general != 0) {
            this.userService.userRate({
                easy: this.easy,
                search: this.search,
                simul: this.simul,
                general: this.general,
                comment: this.comment,
            }).subscribe(invoices => {
                if (this.authenticationService.currentUser.plan == 'trial') {
                    this.authenticationService.currentUser.plan = 'trial_plus';
                }
                if (this.general == 5) {
                    this.step = 2;
                } else {
                    this.step = 3;
                }
            }, error => {
                this.alertService.error('Une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
            });
        } else {
            this.alertService.error('Merci de donner une note pour chaque catégorie');
        }
    }
}
